// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-pf0G","importantInfo":"styles_importantInfo__1OU2J"};